import React, { memo, useCallback } from 'react';
import {
  FooterContainer,
  ContactBar,
  ContactInfo,
  Email,
  SiteToggles,
  IconWrapper,
  ToggleIcon
} from '../styled/Menu.styled';
import { useActiveScreen, useCorporateMode, usePreloading } from '../../contexts/SiteContext';

// Individual icon component that consumes its own context to prevent parent re-renders
const MenuIcon = memo(({ screen, src, alt }) => {
  const { activeScreen, setScreen } = useActiveScreen();
  const { isPreloading } = usePreloading();
  const isActive = activeScreen === screen;
  const handleClick = useCallback((e) => {
    if (isPreloading) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    setScreen(screen, { source: 'footer_menu' });
  }, [setScreen, screen, isPreloading]);

  return (
    <IconWrapper onClick={handleClick} $isActive={isActive}>
      <ToggleIcon src={src} alt={alt} $isActive={isActive} />
    </IconWrapper>
  );
});

MenuIcon.displayName = 'MenuIcon';

const Menu = memo(() => {
  const { isCorporateMode } = useCorporateMode();
  const { isPreloading } = usePreloading();

  const handleEmailClick = useCallback((e) => {
    if (isPreloading) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }, [isPreloading]);

  return (
    <FooterContainer $isCorporateMode={isCorporateMode} $isPreloading={isPreloading}>
      <ContactBar>
        <ContactInfo>
          <Email href="mailto:SAYHELLO@NW.CITY" onClick={handleEmailClick}>SAYHELLO@NW.CITY</Email>
        </ContactInfo>
        
        <SiteToggles $isCorporateMode={isCorporateMode}>
          <MenuIcon 
            screen="tv" 
            src="/icons/tv.png" 
            alt="TV" 
          />
          <MenuIcon 
            screen="news" 
            src="/icons/news.svg" 
            alt="News" 
          />
          <MenuIcon 
            screen="phone" 
            src="/icons/phone.svg" 
            alt="Phone" 
          />
        </SiteToggles>
        
        {/*<SayHelloBtn>
          SAY HELLO
        </SayHelloBtn>*/}
      </ContactBar>
    </FooterContainer>
  );
});

Menu.displayName = 'Menu';

export default Menu;
